import React from 'react';
import { Box } from '@mui/material';

export default function NoInfo() {
  return <Box sx={{ placeItems: 'center', display: 'grid', height: '100%' }}>oops, something went wrong... </Box>;
}
